import React from "react"
import useAccount from "hooks/useUser"
import { Routes as RouterRoutes, Route } from "react-router-dom"
import { PublicRoute } from "./PublicRoute"
import { DashboardLayout } from "components/layouts/DashboardLayout"
import { ProtectedRoute } from "./ProtectedRoute"
import { LoginPage } from "pages/Login"
import { Reimbursement } from "pages/Reimubersement"
import { Categories } from "pages/Categories"
import { SpecificCategory } from "pages/SpecificCategory"
import { Opportunities } from "pages/Opportunities"
import { Tech } from "pages/offices/Tech"
import { Sales } from "pages/offices/Sales"
import { Leads } from "pages/Leads"
import { SignedReps } from "pages/SignedReps"
import { EmployeeRosterPage } from "pages/EmployeeRoster"
import { MediaAds } from "pages/MediaAds"
import { Candidates } from "pages/candidates/Candidates"
import { WeeklyTrainings } from "pages/trainings/WeeklyTrainings"
import { SpecificTraining } from "pages/trainings/SpecificTraining"
import { Blitz } from "pages/blitz/Blitz"
import { SpecificBlitz } from "pages/blitz/SpecificBlitz"
import { RecruitingTools } from "pages/RecruitingTools"
import { VivintAdPricing } from "pages/vivint-ads/VivintAdPricing"
import { VivintAdDetail } from "pages/vivint-ads/VivintAdDetail"
import { VivintCandidates } from "pages/vivint-ads/VivintCandidates"
import {
  VivintSpecificTraining,
  VivintWeeklyTrainings,
} from "pages/vivint-ads/VivintWeeklyShell"
import { GeneralData } from "pages/GeneralData"
import { Contacts } from "pages/Contacts"
import { Giveaway } from "pages/GiveAway"
import { Feedbacks } from "pages/Feedbacks"
import { Users } from "pages/account/Users"
import { Settings } from "pages/Settings"
import { HomePage } from "pages/dashboard2/HomePage"
import { Stats } from "pages/dashboard2/Stats"
import { SpecificStats } from "pages/dashboard2/SpecificStats"
import { VivintLeads } from "pages/VivintLeads"
import { Production } from "pages/Production"
import { Licenses } from "pages/Licenses"
import { Otp } from "pages/Otp"
import { SolarLeadManagement } from "pages/SolarLeadManagement"
import { SolarDetails } from "pages/SolarDetails"
import { RecruiterLocations } from "pages/RecruiterLocations"
import { RepsAndReimbursement } from "pages/RepaAndReimubersement"
import { RegionalReimbursement } from "pages/RegionalReimbursement"
import { Ecards } from "pages/Ecards"
import { RegionalReport } from "pages/RegionalReport"
import { SignedRepsReport } from "pages/SignedRepsReport"
import { MobileReport } from "pages/MobileReport"
import { RanksReport } from "pages/RanksReport"
import { CandidatesReport } from "pages/CandidatesReport"
import { ContactsReport } from "pages/ContactsReport"
import { BlitzReport } from "pages/BlitzReport"
import { WeeklyTrainingsReport } from "pages/WeeklyTrainingsReport"
import { InfoSessions } from "pages/InfoSessions"
import { TrainingUsers } from "components/weekly/TrainingUsers"
import { BreezyData } from "pages/BreezyData"
import { ContactReports } from "pages/ContactReports"
import { WeeklySttats } from "pages/trainings/WeeklyStats"
import { BlackSparrow } from "pages/BlackSparrow"
import { SparrowReport } from "pages/SparrowReport"
import { BlitzStats } from "pages/blitz/BlitzStats"
import { BreezyStats } from "pages/BreezyStats"
import { RegisteredUsers } from "pages/blitz/RegisteredUsers"
import { SparrowReportLocation } from "pages/SparrowReportLocation"
import { BlackSparrowUsers } from "pages/BlackSparrowUsers"
import { ContactStates } from "pages/ContactStates"
import { ContactLeader } from "pages/ContactLeader"
import { SpecificMediaAd } from "pages/SpecificMediaAd"
import { MediaStats } from "pages/MediaStats"
import { AddMediaAd } from "pages/media-ads/AddMediaAd"
import { Dealership } from "pages/Dealership"
import { AdminifyCalendar } from "pages/AdminifyCalendar"
import { SaleAds } from "pages/SaleAds"
import { CompanyDetails } from "pages/CompanyDetails"
import { DealerContacts } from "pages/DealerContacts"
import { DealerTrainings } from "pages/DealerTrainings"
import { DealerMediaAds } from "pages/DealerMediaAds"
import { DealerCandidates } from "pages/DealerCandidates"
import { DealerTrainingDetails } from "pages/DealerDetails"
import { BoardStates } from "pages/BoardStates"
// import { StripePayment } from "pages/StripePayment"
import { Onboarding } from "pages/Onboarding"
import { DelaerReports } from "pages/DealerReports"
import { SpecificDealerAd } from "pages/SpecificDealerAd"
import { ScreenerStats } from "pages/ScreenerStats"
import { MyTrips } from "pages/MyTrips"
import { TripDetails } from "pages/TripDetails"
import { OperationDetails } from "pages/OperationDetails"

export const Routes: React.FC = () => {
  const { isLoggedIn } = useAccount()
  
  return (
    <RouterRoutes>
      <Route
        path="/login"
        element={
          <PublicRoute authorized={isLoggedIn}>
            <LoginPage />
          </PublicRoute>
        }
      />

      <Route path="/dashboard2" element={<HomePage />} />
      <Route path="/dashboard2/stats/:name" element={<SpecificStats />} />
      <Route path="/dashboard2/stats" element={<Stats />} />
      <Route path="/verify" element={<Otp />} />

      <Route element={<DashboardLayout />}>
        <Route
          path="/"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="reimbursement">
              <Reimbursement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/states"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <BoardStates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reps-reimbursement"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="repReimbursement">
              <RepsAndReimbursement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/regional-reimbursement"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="regionalReimbursement">
              <RegionalReimbursement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="video">
              <Onboarding />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealer-reports"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="video">
              <DelaerReports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="video">
              <Categories />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sale-ads"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="saleLeads">
              <SaleAds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adminify-calendar"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="adminifyCalendar">
              <AdminifyCalendar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealer-ads"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <DealerMediaAds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealer-candidates"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <DealerCandidates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact/reports"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <ContactReports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealer-contacts"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <DealerContacts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealer-trainings"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <DealerTrainings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/blitz-stats"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <BlitzStats />
            </ProtectedRoute>
          }
        />
        <Route
          path="/company-details/:id/:badge"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <CompanyDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/weekly-training-stats"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <WeeklySttats />
            </ProtectedRoute>
          }
        />
        <Route
          path="/registered-users"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <RegisteredUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact/states"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <ContactStates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/media-ad/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <SpecificMediaAd />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealer-ad/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <SpecificDealerAd />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact/leader"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <ContactLeader />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealership"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <Dealership />
            </ProtectedRoute>
          }
        />
        <Route
          path="/black-sparrow"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <BlackSparrow />
            </ProtectedRoute>
          }
        />
        <Route
          path="/media-stats"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <MediaStats />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add/media-ad"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <AddMediaAd />
            </ProtectedRoute>
          }
        />
        <Route
          path="/breezy-stats"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <BreezyStats />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sparrow-report/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <SparrowReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sparrow-report-location/:location"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <SparrowReportLocation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sparrow-users"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <BlackSparrowUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vivint-leads"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <VivintLeads />
            </ProtectedRoute>
          }
        />
        <Route
          path="/production"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <Production />
            </ProtectedRoute>
          }
        />
        <Route
          path="/category/:category"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <SpecificCategory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/opportunities"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="opportunities">
              <Opportunities />
            </ProtectedRoute>
          }
        />
        <Route
          path="/offices/tech"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="techoffice">
              <Tech />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leads"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="leads">
              <Leads />
            </ProtectedRoute>
          }
        />
        <Route
          path="/offices/sales"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="salesoffice">
              <Sales />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-trips"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="myTrips">
              <MyTrips />
            </ProtectedRoute>
          }
        />
        <Route
          path="/operation-details/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="operationDetails">
              <OperationDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trip-details/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="tripDetails">
              <TripDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/feedbacks"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="feedbacks">
              <Feedbacks />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reps"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="reps">
              <SignedReps />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-roster"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="employeeRoster">
              <EmployeeRosterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/media-ads"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="ads">
              <MediaAds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/giveway"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="giveaway">
              <Giveaway />
            </ProtectedRoute>
          }
        />
        <Route
          path="/solar-lead-management"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="solar">
              <SolarLeadManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/locations"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="locations">
              <RecruiterLocations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/solar-details/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="solar">
              <SolarDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/candidates"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="candidates">
              <Candidates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/weekly-trainings"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="weekly">
              <WeeklyTrainings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/weekly-trainings/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <SpecificTraining />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vivint-ads/ad/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="mediaAds">
              <VivintAdDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vivint-ads"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="vivintAdsPricing">
              <VivintAdPricing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vivint-ads/candidates"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="vivintCandidates">
              <VivintCandidates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vivint-ads/weekly-trainings/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="mediaAds">
              <VivintSpecificTraining />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vivint-ads/weekly-trainings"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="mediaAds">
              <VivintWeeklyTrainings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealer-details/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <DealerTrainingDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/blitz"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="blitz">
              <Blitz />
            </ProtectedRoute>
          }
        />
        <Route
          path="/blitz/:id"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <SpecificBlitz />
            </ProtectedRoute>
          }
        />
        <Route
          path="/recruiting-tools"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="tools">
              <RecruitingTools />
            </ProtectedRoute>
          }
        />
        <Route
          path="/general-data"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="general">
              <GeneralData />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contacts"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="conctacts">
              <Contacts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="accounts" permittedRoles={["super_admin", "admin"]}>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/licenses"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <Licenses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ecards"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <Ecards />
            </ProtectedRoute>
          }
        />
        <Route
          path="/regional-report"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="ads">
              <RegionalReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/regional-report/signed-reps"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="ads">
              <SignedRepsReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mobile-report"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="ads">
              <MobileReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ranks-report"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="ads">
              <RanksReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/regional-report/candidates"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="ads">
              <CandidatesReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/regional-report/contacts"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="ads">
              <ContactsReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/regional-report/blitz"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="ads">
              <BlitzReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/regional-report/weekly-trainings"
          element={
            <ProtectedRoute authorized={isLoggedIn} permission="ads">
              <WeeklyTrainingsReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/breezy"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <BreezyData />
            </ProtectedRoute>
          }
        />
        <Route
          path="/info-sessions"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <InfoSessions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/screener-stats"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <ScreenerStats />
            </ProtectedRoute>
          }
        />
        <Route
          path="/training-users"
          element={
            <ProtectedRoute authorized={isLoggedIn}>
              <TrainingUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/not-authorized"
          element={<div>You are not authoized, please contact admin.</div>}
        />
        <Route
          path="/coming"
          element={
            <div className="flex flex-col items-center justify-center min-h-screen">
              <h1 className="mb-4 text-5xl font-bold text-gray-900 animate-pulse">
                Coming Soon
              </h1>
              <p className="mb-8 text-lg text-gray-700">
                We're working hard to bring you something amazing. Stay tuned!
              </p>
            </div>
          }
        />
      </Route>
    </RouterRoutes>
  )
}
